export const initialRatings = {
    Rates: [{
        RateCriterium: { name: 'Sound' },
        rates: 0
    },
    {
        RateCriterium: { name: 'Scent' },
        rates: 0
    },
    {
        RateCriterium: { name: 'Texture' },
        rates: 0
    },
    {
        RateCriterium: { name: 'Visual' },
        rates: 0
    },
    {
        RateCriterium: { name: 'Staff' },
        rates: 0
    },
    ],
};
